import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;

  /* Make the table horizontally scrollable on small screens */
  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
`;

export const Thead = styled.thead`
  background-color: #f4f4f4;
`;

export const Th = styled.th`
  padding: 12px;
  text-align: left;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #ddd;

  /* Adjust font size and padding for smaller screens */
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 8px;
  }
`;

export const Tbody = styled.tbody`
  background-color: #fff;
`;

export const Td = styled.td`
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;

  /* Adjust padding for smaller screens */
  @media (max-width: 768px) {
    padding: 8px;
    font-size: 12px;
  }
`;

export const Link = styled.a`
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  /* Adjust link style for small screens */
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
